// Přihlášení a profil: GET /ja (kdo jsem, role, sekce, kategorie, akce — docs/08-autorizace.md §5.3),
// zahájení přihlášení GET /auth/prihlaseni (přesměrování na Entra ID) a POST /auth/odhlaseni.
import type { Ja, OdhlaseniOdpoved } from '@ecoser/shared';
import { useQuery } from '@tanstack/react-query';
import { api, ChybaApi, urlEndpointu } from './klient';

export type { Ja };

export const KLIC_JA = ['ja'] as const;

/**
 * Načte profil přihlášeného. 401 (`neprihlasen`) není chyba, ale běžný stav → `null`;
 * díky tomu react-query nic nehlásí a stav „nepřihlášen“ se nikam neloguje.
 */
export async function nacistJa(signal?: AbortSignal): Promise<Ja | null> {
  try {
    return await api.get<Ja>('/ja', { signal });
  } catch (chyba) {
    if (chyba instanceof ChybaApi && chyba.status === 401) {
      return null;
    }
    throw chyba;
  }
}

/** Dotaz na /ja: bez opakování (401 by jen zdržovalo), čerstvý 60 s. */
export function useJa() {
  return useQuery({
    queryKey: KLIC_JA,
    queryFn: ({ signal }) => nacistJa(signal),
    retry: false,
    staleTime: 60_000,
  });
}

/**
 * URL, na kterou se prohlížeč přesměruje pro přihlášení: backend založí PKCE/state a pošle
 * uživatele na Microsoft (nebo simulátor Entra). `navrat` = relativní cesta v aplikaci po návratu.
 */
export function urlPrihlaseni(navrat = '/'): string {
  return urlEndpointu(`/auth/prihlaseni?navrat=${encodeURIComponent(navrat)}`);
}

/** Zneplatní relaci na serveru; vrací případnou URL pro odhlášení u Microsoftu. */
export function odhlasitNaServeru(): Promise<OdhlaseniOdpoved | undefined> {
  return api.post<OdhlaseniOdpoved | undefined>('/auth/odhlaseni');
}
